// extracted by mini-css-extract-plugin
export var cont = "timeline-module--cont--n1UvU";
export var timeline = "timeline-module--timeline--P0YDe";